module.exports = __webpack_public_path__ + "img/Veranza-23-min.93b01e55.jpg";